<template>
  <div :class="classes" :style="styles" @click="back">
      <slot>
        <div :class="innerClasses">
          <svg style="fill: white" xmlns="http://www.w3.org/2000/svg" width="53" height="20">
            <path d="M43.886 16.221l-1.189 1.466L26.5 4.731 10.303 17.688l-1.189-1.467L26.5 2.312z"/>
          </svg>
        </div>
      </slot>
  </div>
</template>

<script>
  import { scrollTop } from '@/assets/js/assist'
  import { on, off } from '@/assets/js/dom'

  const prefixClass = 'BackTop'

  export default {
    name: 'BackTop',

    props: {
      height: {
        type: Number,
        default: 1400
      },
      bottom: {
        type: Number,
        default: 20
      },
      left: {
        type: Number,
        default: 40
      },
      duration: {
        type: Number,
        default: 750
      }
    },

    data () {
      return {
        backTop: false
      }
    },

    mounted () {
      on(window, 'scroll', this.handleScroll)
      on(window, 'resize', this.handleScroll)
    },

    beforeDestroy () {
      off(window, 'scroll', this.handleScroll)
      off(window, 'resize', this.handleScroll)
    },

    computed: {
      classes () {
        return [
          `${prefixClass}`,
          {
            [`${prefixClass}-show`]: this.backTop
          }
        ]
      },
      styles () {
        return {
          bottom: `${this.bottom}px`,
          left: `${this.left}px`
        }
      },
      innerClasses () {
        return `${prefixClass}-inner`
      }
    },

    methods: {
      handleScroll () {
        this.backTop = window.pageYOffset >= this.height
      },
      back () {
        const sTop = document.documentElement.scrollTop || document.body.scrollTop
        scrollTop(window, sTop, 0, this.duration)
        this.$emit('on-click')
      }
    }

  }
</script>

<style lang="sass" scoped>
.BackTop
    z-index: 1
    position: fixed
    cursor: pointer
    display: none
    animation: floating 1800ms ease-in-out infinite, fadeIn ease-in-out 1s

    &.BackTop-show
        display: block

    &-inner
        transition: all .2s ease-in-out
        animation: zoomIn 2s
        // &:hover
        //     fill: red


@keyframes zoomIn
    from
        opacity: 0
        transform: scale3d(.3, .3, .3)
    50%
        opacity: 1
</style>



// WEBPACK FOOTER //
// src/components/BackTop.vue